jQuery(document).ready(function ($) {
  let interval = setInterval(function () {
    $('.yotpo-reviews-carousel-header-container').append($('.yotpo-reviews-carousel-bottomline-seo'));
    if ($('.yotpo-reviews-carousel-bottomline-seo').length > 0) {
      clearInterval(interval);
    }
  }, 300);

  $('.grid__item:has(input[name="oversellProductId"])').each(function () {
    let oversellProducts = $(this).find('input[name="oversellProductId"]').val();
    let allEUCountries = ["BE", "FR", "DE", "LU", "NL", "AT", "DK", "HU", "IE", "IT", "LV", "PL", "PT", "SK", "SI", "ES", "SE", "GR", "AX", "JE", "LT", "MT", "RO", "BG", "CY", "EE", "FO", "GI", "GL", "GP", "GG", "VA", "YT", "MK", "RE", "SM", "SJ", "IM", "HR"]
    let allGBCountries = ["AL", "AD", "AM", "AZ", "BY", "BA", "GE", "IS", "XK", "LI", "MD", "MC", "ME", "NO", "RS", "CH", "TR", "UA"]
    let USCountries = ["US"]
    let AUCountries = ["AU", "NZ"]
    let CACountries = ["CA"]

    let htmlOversellCountries = $(this).find('input[name="oversellCountries"]').val().replaceAll('[', '').replaceAll(']', '').replaceAll("'", '').split(',');
    let finalOversellCountries = [];

    htmlOversellCountries.forEach(country => {
      if (country == 'All EU Countries') {
        finalOversellCountries = finalOversellCountries.concat(allEUCountries);
      } else if (country == 'All GB Countries') {
        finalOversellCountries = finalOversellCountries.concat(allGBCountries);
      } else if (country == 'USA') {
        finalOversellCountries = finalOversellCountries.concat(USCountries);
      } else if (country == 'Australia') {
        finalOversellCountries = finalOversellCountries.concat(AUCountries);
      } else if (country == 'Canada') {
        finalOversellCountries = finalOversellCountries.concat(CACountries);
      }
    });
    
    const countryMap = {"CA": CACountries, "NL": allEUCountries, "US": USCountries, "AU": AUCountries, "GB": allGBCountries}

    const countryToWarehouseMap = (warehouseToCountryMap) => {
      let cTWMap = {};

      for (let warehouse in warehouseToCountryMap){
        let countries=warehouseToCountryMap[warehouse];

        for (let i=0; i<countries.length; i++){
          cTWMap[countries[i]] = warehouse
        }
      }
          
      return cTWMap
    }

    const warehouseMap = countryToWarehouseMap(countryMap)

    function getWarehouseForCountry(countryCode) {
      return warehouseMap[countryCode] || "US";
    }

    let oversellCountries = finalOversellCountries;

    // Get product ID of product
    const productId = oversellProducts
    if (oversellProducts.includes(productId.toString())){
      // API Url and body to get the inventory levels per country
      const fullUrl = 'https://62uv9g1ee9.execute-api.us-east-1.amazonaws.com/';
      const body = {"getAllProductVariants": true, "productId": productId}
      let productGridItem = $(this);
      let elm = productGridItem.find('.inventory_quantity');
      let variantId = elm.data('variant-id');
      fetch(fullUrl, {
        method: 'POST',
        body: JSON.stringify(body)
      }).then(res => res.json()).then(data => {
        elm.attr('data-variant-inventory_quantity', JSON.stringify(data))
        disableAddToCartIfVariantIsNotAvailable(variantId, JSON.stringify(data), productGridItem)
      }).catch(err => console.log(err))  
    }

    function canOversell(productId, countryCode) {
      if(warehouseMap[countryCode]){
        return oversellProducts.includes(productId.toString()) && oversellCountries.includes(countryCode);
      } else {
        let warehouse = getWarehouseForCountry(countryCode);
        return oversellProducts.includes(productId.toString()) && oversellCountries.includes(warehouse);
      }
    }

    function disableAddToCartIfVariantIsNotAvailable(variantId, allVariantInventoryQuantity, productGridItem){
      if (variantId !== null){
        let variantInventoryQuantity = allVariantInventoryQuantity
        
        if (variantInventoryQuantity !== ""){
          try{
            const variantInventoryCounts = JSON.parse(variantInventoryQuantity)[variantId.toString()]
            const userCountryCode = localStorage.getItem("country_code");
            
            if (getWarehouseForCountry(userCountryCode)){
              
              const warehouseCode = (warehouseMap && warehouseMap[userCountryCode]) || "US";
              
              if (warehouseCode in variantInventoryCounts){
                const addToCartBtn = productGridItem.find('.btn.add-to-cart')[0];
                let variantCount;
                if (warehouseCode in variantInventoryCounts){
                  variantCount = variantInventoryCounts[warehouseCode]
                } else {
                  variantCount = 0
                }
                
                if (variantCount <= 0){
                  if (!canOversell(productId, userCountryCode)){
                    addToCartBtn.classList.add("disabled");
                    addToCartBtn.disabled = true;
                    addToCartBtn.value = "Sold Out"
                    addToCartBtn.innerHTML = "Sold Out"
                    addToCartBtn.innerText = "Sold Out"
                  }
                } else {
                  addToCartBtn.classList.remove("disabled");
                  addToCartBtn.disabled =false;
                  addToCartBtn.value = "Add to cart"
                  addToCartBtn.innerHTML = "Add to cart"
                  addToCartBtn.innerText = "Add to cart"
                }
              } else {
                const addToCartBtn = productGridItem.find('.btn.add-to-cart')[0];
                if (oversellProducts.includes(productId.toString())){
                  addToCartBtn.classList.add("disabled");
                  addToCartBtn.disabled = true;
                  addToCartBtn.value = "Sold Out"
                  addToCartBtn.innerHTML = "Sold Out"
                  addToCartBtn.innerText = "Sold Out"
                }
              }
            } 
          } catch (err) { console.log(err)}
        }
      }
    }
  });
});
